import { CSSInterpolation } from '@emotion/serialize';
import React from 'react';
import { testResponsiveValue } from '../../theme/utils';
import Box, { BoxProps } from '../Box';
import { withDeprecationWarnings } from '../_internal/DeprecationWarning';

interface AppearanceProps {}

export type GridProps = Omit<BoxProps, 'display' | 'gridTemplateColumns'> &
  AppearanceProps;

const gridStyle: CSSInterpolation = {
  maxWidth: '1200px',
  margin: '0 auto',
  display: 'grid',
  gridTemplateColumns: 'repeat(12, 1fr)',
};

const Grid: React.FC<GridProps> = React.memo(function Grid(props) {
  return <Box css={gridStyle} {...props} />;
});

Grid.displayName = 'Grid';

export const GridStoryComponent = Grid;

export default withDeprecationWarnings<GridProps>(Grid, [
  {
    prop: 'wrap',
    message: "Grid's `wrap` prop is no longer effective",
    predicate: testResponsiveValue(v => typeof v !== 'undefined'),
  },
]);
